import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { Domain, Owner, TagLabelBasic } from '@/shared/types';

export type DatabaseSchemaUsageStats = {
  count: number;
  percentileRank: number;
};

export type DatabaseSchemaUsageSummary = {
  dailyStats: DatabaseSchemaUsageStats;
  weeklyStats: DatabaseSchemaUsageStats;
  monthlyStats: DatabaseSchemaUsageStats;
  date: string;
};

export type DatabaseSchemaService = {
  id: string;
  type: string;
  name: string;
  fullyQualifiedName: string;
  description: string;
  displayName: string;
  deleted: boolean;
  href: string;
};

export type DatabaseSchemaDatabase = {
  id: string;
  type: string;
  name: string;
  fullyQualifiedName: string;
  displayName: string;
  deleted: boolean;
  href: string;
};

export type DatabaseSchema = {
  id: string;
  name: string;
  fullyQualifiedName: string;
  description?: string;
  dataProducts: Domain[];
  version: number;
  updatedAt: number;
  updatedBy: string;
  href: string;
  owners: Owner[];
  service: DatabaseSchemaService;
  serviceType: string;
  database: DatabaseSchemaDatabase;
  usageSummary?: DatabaseSchemaUsageSummary;
  tags: TagLabelBasic[];
  deleted: boolean;
  sourceUrl?: string;
  domains: Domain[];
  sourceHash: string;
};

export type DatabaseSchemasResponse = {
  data: DatabaseSchema[];
  paging: {
    total: number;
  };
};

export const fetchDatabaseSchemas = async (
  databaseFqn: string,
  params: {
    includeDeleted?: boolean;
    limit?: number;
    fields?: string;
  } = {}
): Promise<DatabaseSchemasResponse> => {
  const response = await openMetadataApiClient.get<DatabaseSchemasResponse>('/databaseSchemas', {
    params: {
      database: databaseFqn,
      include: params.includeDeleted ? 'deleted' : 'non-deleted',
      limit: params.limit || 15,
      fields: params.fields || 'usageSummary,tags,owners,domains',
    },
  });

  return response.data;
};
